/**
 * 送货上门图标
 */
const HomeDeliveryIcon = ({ width = 20, height = 20, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M3.75 14.1113H1.25V8.99414L4.59625 7.8125V3.125H17.7213V5.87158M7.5 14.1113H11.875M15.625 14.1113H17.7213V9.24316"
        stroke="black"
        strokeWidth="1.25"
        strokeLinecap="square"
      />
      <path d="M10.625 6.25H19.375" stroke="black" strokeWidth="1.25" />
      <path d="M14.375 8.75H20" stroke="black" strokeWidth="1.25" />
      <circle
        cx="5.625"
        cy="14.375"
        r="1.875"
        stroke="black"
        strokeWidth="1.25"
        strokeLinecap="square"
      />
      <circle
        cx="13.75"
        cy="14.375"
        r="1.875"
        stroke="black"
        strokeWidth="1.25"
        strokeLinecap="square"
      />
    </svg>
  )
}

export default HomeDeliveryIcon
